var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card card-green"},[_c('div',{staticClass:"card-body"},[_c('DocumentWin',{attrs:{"childId":_vm.$route.params.userId,"type":'normal'}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }